export const QA_NAME_APPLICANT_FIT_CHECK = 'applicantFitCheck'

export const QA_NAME_APPLICANT_FIT_CHECK_SCORE_LINE = 'applicantFitCheckScore'

export const QA_NAME_APPLICANT_FIT_CHECK_REEVALUATE =
  'applicantFitCheckReevaluate'

export const QA_NAME_APPLICANT_FIT_CHECK_STALE = 'applicantFitCheckStale'

export const QA_NAME_APPLICANT_FIT_CHECK_BREAKDOWN =
  'applicantFitCheckBreakdown'

export const QA_NAME_APPLICANT_FIT_CHECK_EDIT = 'applicantFitCheckEdit'

export const QA_NAME_APPLICANT_FIT_CHECK_LISTING_LINK =
  'applicantFitCheckListingLink'

export const MATCH_UNAVAILABLE_REASON_KEY = {
  listing_missing_availability: 'RentalPortal.MatchUnavailableAvailabilityKey',
}
